import { Backdrop, CircularProgress } from "@mui/material";
import { styled } from "@mui/system";

interface ProgressSpinnerProps {
  showSpinner: boolean;
}

const ProgressBackdrop = styled(Backdrop)({
  zIndex: 1500,
  color: "#ffffff",
});

const ProgressSpinner: React.FC<ProgressSpinnerProps> = ({ showSpinner }) => {
  return (
    <ProgressBackdrop open={Boolean(showSpinner)}>
      <CircularProgress color="inherit" thickness={5} size={100} />
    </ProgressBackdrop>
  );
};

export default ProgressSpinner;
